import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("dig-ui-loader")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Erreur", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Une erreur est survenue lors du chargement des données.", -1)
const _hoisted_8 = { key: 2 }

import LameForm from '@/components/LameForm.vue'
import ProductInfo from '@/components/ProductInfo.vue'
import AccessoiresForm from '@/components/AccessoiresForm.vue'
import OutputImage from '@/components/OutputImage.vue'
import OutputProducts from '@/components/OutputProducts.vue'
import { computed, onMounted, Ref, ref } from 'vue'
import { apiHandler } from './api/ApiHandler'
import { ChoosenAccessoire, DEFAULT_SURFACE, IProduct } from '@/model/Product'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(false)
const errored = ref(false)
const productInfo: Ref<IProduct | undefined> = ref(undefined)
const surface = ref(DEFAULT_SURFACE)
const products: Ref<IProduct[]> = ref([])
const choosenLame: Ref<IProduct | undefined> = ref()
const choosenLameAccessoire: Ref<ChoosenAccessoire | undefined> = ref()
const choosenAccessoires: Ref<ChoosenAccessoire[]> = ref([])

const lames = computed(() => {
  return products.value.filter((p) => p.categorie !== 'ac')
})

const accessoires = computed(() => {
  return products.value.filter((p) => p.categorie === 'ac')
})

const choosenProducts = computed(() => {
  if (choosenLame.value) {
    return [...choosenAccessoires.value] as ChoosenAccessoire[]
  }
  return choosenAccessoires.value as ChoosenAccessoire[]
})

const ml = computed(() => {
  return choosenLameAccessoire.value
    ? Math.ceil(choosenLameAccessoire.value.quantity / 2) *
        2 *
        +choosenLameAccessoire.value.product.longueur
    : 0
})

onMounted(async () => {
  await init()
})

const init = async () => {
  loading.value = true
  const response = await apiHandler.get('')
  loading.value = false

  if (response.success) {
    products.value = response.products
  } else {
    errored.value = true
  }
}

const updateLame = (lame?: IProduct) => {
  choosenLame.value = lame
}

const updateLameAccessoire = (lame?: ChoosenAccessoire) => {
  choosenLameAccessoire.value = lame
}

const updateAccessoires = (accessoire?: ChoosenAccessoire) => {
  if (
    !accessoire ||
    !accessoire.product ||
    !accessoire.product.idp ||
    !accessoire.product.idd
  )
    return
  const current = choosenAccessoires.value.find(
    (a) => a.product.idp === accessoire.product.idp,
  )
  if (current) {
    choosenAccessoires.value = choosenAccessoires.value.map((a) => {
      return a.product.idp === accessoire.product.idp ? accessoire : a
    })
  } else {
    choosenAccessoires.value.push(accessoire)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (errored.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("dig-ui-standard-button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (init()))
            }, " Recharger la page ")
          ])
        ]))
      : _createCommentVNode("", true),
    (!errored.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(LameForm, {
            class: "lame-form",
            lames: _unref(lames),
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (updateLame($event))),
            onUpdateAccessoire: _cache[2] || (_cache[2] = ($event: any) => (updateLameAccessoire($event))),
            onUpdateSurface: _cache[3] || (_cache[3] = ($event: any) => (surface.value = $event))
          }, null, 8, ["lames"]),
          _createVNode(ProductInfo, {
            product: productInfo.value,
            onReset: _cache[4] || (_cache[4] = ($event: any) => (productInfo.value = undefined))
          }, null, 8, ["product"]),
          _createVNode(OutputImage, { lame: choosenLame.value }, null, 8, ["lame"]),
          _createVNode(AccessoiresForm, {
            accessoires: _unref(accessoires),
            lame: choosenLame.value,
            onUpdate: _cache[5] || (_cache[5] = ($event: any) => (updateAccessoires($event))),
            onUpdateInfo: _cache[6] || (_cache[6] = ($event: any) => (productInfo.value = $event))
          }, null, 8, ["accessoires", "lame"]),
          _createVNode(OutputProducts, {
            products: _unref(choosenProducts),
            lame: choosenLameAccessoire.value,
            ml: _unref(ml),
            surface: surface.value
          }, null, 8, ["products", "lame", "ml", "surface"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})